
import EmailSend from "./module/EmailSend";

document.addEventListener('DOMContentLoaded', function() {
    const emailmanagement = new EmailSend(); 
});